export default __webpack_public_path__ + "static/media/template_01.50ca6bcb.jpg";